export default {
  path: 'suppliers',
  name: 'supplier',
};
